<template>
  <div>
    <Pagination />
    <Result
      v-for="result in results"
      :key="result._id"
      :result="result"
      :query="query"
    >
    </Result>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import Pagination from '@/components/search/Pagination'
import Result from '@/components/search/Result'

export default {
  components: {
    Pagination,
    Result,
  },

  computed: {
    ...mapState({
      results: state => state.search.results,
      query: state => state.search.queryArr,
    }),
  },
}
</script>
